export function lockBodyScroll(
  fixBody: boolean = false,
  overflowYScroll: boolean = true,
) {
  if (!!document && typeof document !== 'undefined') {
    const body: HTMLElement = document?.body;
    const html: HTMLElement = document?.documentElement;
    html.classList.add('overflow-y-hidden');
    body.classList.add('w-full');
    if (overflowYScroll) body.classList.add('overflow-y-scroll');
    if (fixBody) body.classList.add('fixed');
  }
}
export function unlockBodyScroll() {
  const auth = useAuthStore();
  const settings = useSiteStore();
  if (
    !!document &&
    typeof document !== 'undefined' &&
    !settings.getModalActive &&
    !auth.displayAccountModal
  ) {
    const body: HTMLElement = document?.body;
    const html: HTMLElement = document?.documentElement;
    html.classList.remove('overflow-y-hidden');
    body.classList.remove('fixed');
    body.classList.remove('overflow-y-scroll');
    body.classList.remove('w-full');
  }
}
export function boundaryErrorReporter({
  file,
  componentBoundary,
  err,
}: {
  file: string;
  componentBoundary: string;
  err: unknown;
}) {
  console.error({ type: `UI Boundary Error`, file, componentBoundary, err });
}

export const scrollToTop = () => {
  document?.body?.scrollTo({ top: 0, behavior: 'smooth' });
};

export const setBrandColors = () => {
  const siteStore = useSiteStore();
  document.documentElement.style.setProperty(
    '--brand-color',
    siteStore.region === 'ZA' ? '#005FE8' : '#d839ff',
  );
  document.documentElement.style.setProperty(
    '--brand-color-darker',
    siteStore.region === 'ZA' ? '#290731' : '#5b186b',
  );
  document.documentElement.style.setProperty(
    '--brand-linear-gradient-to-color',
    '#290731',
  );
};
